/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import DataPanel from "./DataPanel";
import DetailPanel from "./DetailPanel";

const useStyles = makeStyles(() => ({
  userMainContainer: {
    background: "#F8FCFF",
    height: "calc(100vh - 50px)",
    overflow: "hidden",
  },
  h3: {
    background: "#FFFFFF",
    fontSize: "20px",
    padding: "10px",
    borderBottom: "1px solid #0000001F",
    margin: "0",
  },
  panelContainer: {
    width: "100%",
    display: "flex",
  },
  leftPanel: {
    width: "45%",
    height: "calc(100vh - 95px)",
    // background: "antiquewhite",
    borderRight: "1px solid #0000001F",
  },
  rightPanel: {
    width: "55%",
    height: "100%",
    padding: "0px 10px",
    // border: "1px solid black",
    // background: "lightgreen",
  },
}));

const UserManagement = () => {
  const classes = useStyles();
  const [toggle, setToggle] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [menuType, setMenuType] = useState("user");
  const [isNew, setIsNew] = useState(false);
  const [isTableUpdated, setIsTableUpdated] = useState(false);
  const [deleted, setdeleted] = useState(false);
  const [newdata, setnewdata] = useState(null);
  const [isCreate, setisCreate] = useState(false);
  // console.log("parent", selectedData);
  useEffect(() => {
    console.log("dele");
  }, [selectedData, isTableUpdated]);
  return (
    <div className={classes.userMainContainer}>
      <h3 className={classes.h3}>User Management</h3>
      <div className={classes.panelContainer}>
        <div className={classes.leftPanel} data-testid="datapanel">
          <DataPanel
            toggle={toggle}
            setToggle={setToggle}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            isNew={isNew}
            setIsNew={setIsNew}
            menuType={menuType}
            setMenuType={setMenuType}
            isTableUpdated={isTableUpdated}
            setIsTableUpdated={setIsTableUpdated}
            deleted={deleted}
            setdeleted={setdeleted}
            isCreate={isCreate}
            newdata={newdata}
            setisCreate={setisCreate}
          />
        </div>
        <div className={classes.rightPanel} data-testid="detailpanel">
          <DetailPanel
            selectedData={selectedData && toggle && selectedData}
            menuType={menuType}
            isNew={isNew}
            setIsNew={setIsNew}
            isTableUpdated={isTableUpdated}
            setIsTableUpdated={setIsTableUpdated}
            setdeleted={setdeleted}
            setisCreate={setisCreate}
            setnewdata={setnewdata}
          />
        </div>
      </div>
    </div>
  );
};

export default UserManagement;
